export const rulesView = [
  {
    id: 1,
    title: "土の力を取り戻そう",
  },
  {
    id: 2,
    title: "生態系のバランスを<br class='pcOnly' />取り戻そう",
  },
  {
    id: 3,
    title: "温室効果ガスを<br class='pcOnly' />吸収しよう",
  },
  {
    id: 4,
    title: "水をきれいにしよう",
  },
  {
    id: 5,
    title: "資源を循環させよう",
  },
  {
    id: 6,
    title: "地球にやさしい農業で<br />収量を維持しよう",
  },
  {
    id: 7,
    title: "おいしさと栄養を<br class='pcOnly' />高めよう",
  },
  {
    id: 8,
    title: "農家さんの未来を守ろう",
  },
  {
    id: 9,
    title: "みんなが<br />参加できるものにしよう",
  },
  {
    id: 10,
    title: "農業の素晴らしさを<br />世界のみんなに広めよう",
  },
];

export const rules = [
  {
    id: 1,
    title: "土の力を取り戻そう",
  },
  {
    id: 2,
    title: "生態系のバランスを<br />取り戻そう",
  },
  {
    id: 3,
    title: "温室効果ガスを<br />吸収しよう",
  },
  {
    id: 4,
    title: "水をきれいにしよう",
  },
  {
    id: 5,
    title: "資源を循環させよう",
  },
  {
    id: 6,
    title: "地球にやさしい農業で<br />収量を維持しよう",
  },
  {
    id: 7,
    title: "おいしさと栄養を<br />高めよう",
  },
  {
    id: 8,
    title: "農家さんの<br class='spOnly' />未来を守ろう",
  },
  {
    id: 9,
    title: "みんなが<br />参加できるものに<br class='spOnly' />しよう",
  },
  {
    id: 10,
    title: "農業の素晴らしさを<br />世界のみんなに<br />広めよう",
  },
];

export const directories = [
  {
    title: "Vegetables",
    url: "/vegetables/",
  },
  {
    title: "Method",
    url: "/method/",
  },
  {
    title: "Soil Solution",
    url: "/method/soil-solution/",
  },
  {
    title: "Agri LCA+",
    url: "/method/agrilca/",
  },
  {
    title: "Next Green Credit",
    url: "/method/next-green-credit/",
  },
  {
    title: "10Rules",
    url: "/10rules/",
  },
  {
    title: "About Us",
    url: "/about/",
  },
  {
    title: "For Farmers",
    url: "/for-farmers/",
  },
  {
    title: "For Companies",
    url: "/for-companies/",
  },
  {
    title: "For Everyone",
    url: "/for-everyone/",
  },
  {
    title: "News",
    url: "/news/",
  },
  {
    title: "Contact",
    url: "/contact/",
  },
  ...[
    ["farmers", "農家様"],
    ["companies", "企業様"],
    ["media", "メディア向け"],
    ["general", "その他"],
  ].map(([slug, title], i) => ({
    title: `${title}お問い合わせフォーム`,
    url: `/contact/${slug}/`,
  })),
];
